import React from 'react';
import { ReferenceData } from '../services/referenceDataService';
import { useTerminologyContext } from '../context/TerminologyContext';

export const useReferenceData = () => {
  const context = useTerminologyContext();
  const { load } = context;
  React.useEffect(() => {
    void load();
  }, [load]);
  return context;
};

export const useReferenceOptions = (category: Exclude<keyof ReferenceData, 'version'>) => {
  const context = useReferenceData();
  return {
    options: context.data?.[category] || [],
    loading: context.loading,
    error: context.error,
    retry: context.retry,
    version: context.data?.version,
  };
};
